/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_DISCOUNT_BOX } from "../graphql/createDiscountBox.mutation";

const is = require("is_js");
export interface ICreateDiscountBoxArgs {
  presentationID: string;
  sectionID: string;
  email: string;
  sponserName: string;
  partition: string;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateDiscountBoxTypeMethods extends IPluginMethodMap {
  createDiscountBox(args: any): Promise<any>;
}

export class CreateDiscountBoxService implements IAgentPlugin {
  readonly methods: ICreateDiscountBoxTypeMethods;

  constructor() {
    this.methods = {
      createDiscountBox: this.createDiscountBox.bind(this),
    };
  }

  async createDiscountBox(args: ICreateDiscountBoxArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_DISCOUNT_BOX,
          variables: {
            data: {
              presentation: args?.presentationID,
              section: args?.sectionID,
              email: args?.email,
              discount: {
                sponserName: args?.sponserName,
                lateAssociation: true,
                type: "Total",
              },
              items: args?.items,
              partition: args?.partition,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (
          res?.data?.createDiscountBox &&
          is.existy(res?.data?.createDiscountBox)
        ) {
          return res?.data?.createDiscountBox;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
